export default function(modalClass, buttonClass, contentClass, backdropClass, closeClass) {

    const modal = document.querySelectorAll(modalClass)[0]
    const button = document.querySelectorAll(buttonClass)[0]
    const backdrop = document.querySelectorAll(backdropClass)[0]
    const content = document.querySelectorAll(contentClass)[0]
    const close = document.querySelectorAll(closeClass)[0]


    const youtubeId = button == null ? null : button.dataset.youtubeId
    let isOpened = false

    const toggleClass = function(e) {
        e.preventDefault()
        e.stopPropagation()
        modal.classList.toggle('is-visible')
        isOpened = !isOpened
    }

    const open = function(e) {
        content.innerHTML = '<div class="video-player__container video-player__container--static"><iframe width="648" height="405" src="' + generateYoutubeUrl(youtubeId) +'" frameborder="0" allowfullscreen class="video-player video-player--youtube"></iframe></div>'
        toggleClass(e)
        backdrop.addEventListener('click', dismiss)
        close.addEventListener('click', dismiss)
    }

    const dismiss = function(e) {
        toggleClass(e)
        backdrop.removeEventListener('click', dismiss)
        close.removeEventListener('click', dismiss)
        content.innerHTML = ''
    }

    const toggleNav = function(e) {

        if ( isOpened ) {
            dismiss(e)
        } else {
            open(e)
        }

    }

    const generateYoutubeUrl = function(id) {
        return '//www.youtube-nocookie.com/embed/' + id + '?rel=0'
    }


    if ( modal != null && button != null && backdrop != null && content != null && close != null && youtubeId != null) {
        button.addEventListener('click', toggleNav)
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/web/video.js